import {dom, library} from '@fortawesome/fontawesome-svg-core';
import {definition as faChevronDown} from '@fortawesome/free-solid-svg-icons/faChevronDown'
import {definition as faChevronUp} from '@fortawesome/free-solid-svg-icons/faChevronUp'
import {definition as faSearch} from '@fortawesome/free-solid-svg-icons/faSearch'
import {definition as faSpinner} from '@fortawesome/free-solid-svg-icons/faSpinner'

export default class FontAwesomeBuilder {
  public static buildLibrary() {
    library.add(
      faChevronDown,
      faChevronUp,
      faSearch,
      faSpinner,
    );

    dom.watch();
  }
}
